<template>
  <v-layout
    column
    justify-center
    class="pr-2"
  >
    <!-- No access yet -->
    <v-layout
      v-if="userHasNoAccessYet"
      justify-center
      align-center
    >
      <!-- Note: Fixed width aligns it with icons/placeholders in the other rows. -->
      <span
        class="warning--text"
        data-cy="usermanagement-no-acess-yet-warning"
        style="width: 168px;"
      >{{ $t('userHasNoAccessYet') }}</span>
    </v-layout>
    <!-- Access counts -->
    <v-layout
      v-else
      justify-center
      align-center
    >
      <!-- GroupAccess: Read -->
      <div
        v-if="numGroupAccessesRead"
        class="mr-4 py-1"
        :title="numGroupAccessesReadTooltip"
      >
        <v-layout align-center>
          <v-icon
            class="mr-1"
            color="msr"
          >
            visibility
          </v-icon>
          <strong
            class="msr--text subheading"
            style="min-width: 24px;"
          >{{
            numGroupAccessesRead
          }}</strong>
        </v-layout>
      </div>
      <div
        v-else
        class="mr-4 py-1"
        style="min-width: 52px;"
      >
        <!-- Placeholder for alignment -->
      </div>
      <!-- GroupAccess: Write -->
      <div
        v-if="numGroupAccessesWrite"
        :title="numGroupAccessesWriteTooltip"
        class="mr-4 py-1"
      >
        <v-layout align-center>
          <v-icon
            class="mr-1"
            color="msr"
          >
            edit
          </v-icon>
          <strong
            class="msr--text subheading"
            style="min-width: 24px;"
          >{{
            numGroupAccessesWrite
          }}</strong>
        </v-layout>
      </div>
      <div
        v-else
        class="mr-4 py-1"
        style="min-width: 52px;"
      >
        <!-- Placeholder for alignment -->
      </div>
      <!-- StoreAccess: Read/Write -->
      <div
        v-if="numStoreAccesses"
        :title="numStoreAccessesTooltip"
        class="py-1"
      >
        <v-layout align-center>
          <v-icon
            class="mr-1"
            color="msr"
          >
            location_on
          </v-icon>
          <strong
            class="msr--text subheading"
            style="min-width: 24px;"
          >{{
            numStoreAccesses
          }}</strong>
        </v-layout>
      </div>
      <div
        v-else
        class="py-1"
        style="min-width: 52px;"
      >
        <!-- Placeholder for alignment -->
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
import accessConstants from '@/mixins/accessConstants.js';

export default {
  name: 'UserAccessesMiniOverview',
  mixins: [accessConstants],
  props: {
    /** Expects a managed User with a .groupaccess field. */
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    numGroupAccessesRead() {
      let num = 0;
      for (let groupaccess of this.user.groupaccesses) {
        num += 1; // Can see contents.
        if (groupaccess.role === this.GA_ACCESS_ROLE_STORE) {
          num += 1; // Can see stores.
        }
      }
      return num;
    },
    numGroupAccessesReadTooltip() {
      return this.$t('userManagementGroupAccessCountRead').replace(
        '{{ num }}',
        this.numGroupAccessesRead
      );
    },
    numGroupAccessesWrite() {
      let num = 0;
      for (let groupaccess of this.user.groupaccesses) {
        if (groupaccess.can_manage_content) {
          num += 1; // Can manage contents.
        }
        if (
          groupaccess.role === this.GA_ACCESS_ROLE_STORE &&
          groupaccess.level === this.GA_ACCESS_LEVEL_FULL
        ) {
          num += 1; // Can manage stores.
        }
      }
      return num;
    },
    numGroupAccessesWriteTooltip() {
      return this.$t('userManagementGroupAccessCountWrite').replace(
        '{{ num }}',
        this.numGroupAccessesWrite
      );
    },
    numStoreAccesses() {
      return this.user.storeaccesses.length;
    },
    numStoreAccessesTooltip() {
      return this.$t('userManagementStoreAccessCount').replace(
        '{{ num }}',
        this.numStoreAccesses
      );
    },
    userHasNoAccessYet() {
      return (
        this.numGroupAccessesRead +
          this.numGroupAccessesWrite +
          this.numStoreAccesses ===
        0
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserManagement/UserAccessesMiniOverview.vue